import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  Tooltip,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { peticionGet } from "Componentes/ComponenteAxios";
const BarraNavegacion = ({ titulo, onLogout }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElVisualizacion, setAnchorElVisualizacion] = useState(null);
  const open = Boolean(anchorEl);
  const openVisualizacion = Boolean(anchorElVisualizacion);

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClickVisualizacion = (event) =>
    setAnchorElVisualizacion(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleMenuCloseVisualizacion = () => setAnchorElVisualizacion(null);
  const handleNavigate = (path) => {
    handleMenuClose();
    handleMenuCloseVisualizacion();
    navigate(path);
  };
  const handleNavigateVisualizacion = (path) => {
    handleMenuCloseVisualizacion();
    navigate(path);
  };
  const [empresa, setEmpresa] = React.useState(null);

  const [anchorElInformes, setAnchorElInformes] = useState(null);
  const openInformes = Boolean(anchorElInformes);
  const handleMenuClickInformes = (event) =>
    setAnchorElInformes(event.currentTarget);
  const handleMenuCloseInformes = () => setAnchorElInformes(null);
  const handleNavigateInformes = (path) => {
    handleMenuCloseInformes();
    navigate(path);
  };
  const menuItems = [
    { label: "Puestos de Trabajo", path: "/puestosTrabajo" },
    { label: "Departamentos y Secciones", path: "/departamentosSedes" },
    { label: "Asignaciones de Puestos", path: "/asignacionesPuestos" },
    { label: "Agrupaciones de Turnos", path: "/agrupacionesTurnos" },
    { label: "Tramos de Día", path: "/tramosDia" },
    { label: "Necesidades de Personal", path: "/necesidadesPersonal" },
    { label: "Patrones", path: "/Patrones" },
    { label: "Plantillas Anuales", path: "/plantillasAnuales" },

    { label: "Asignar Plantillas", path: "/AsignarPlantillas" },
  ];
  const menuItemsVisualizacion = [
    { label: "Trabajadores", path: "/Trabajadores" },
    { label: "Turnos", path: "/turnos" },
    { label: "Pausas", path: "/pausas" },
  ];
  const menuItemsInformes = [
    { label: "Mensuales", path: "/Informes" },
    { label: "Semanales", path: "/InformesSemanales" },
  ];
  React.useEffect(() => {
    const cargarEmpresa = async () => {
      const { peticion, error } = await peticionGet(`/empresa`);
      if (!error) {
        console.log(peticion.datos);
        setEmpresa(peticion.datos);
      }
    };
    cargarEmpresa();
  }, []);
  if (!empresa) {
    return;
  }
  return (
    <AppBar position="static">
      <Toolbar>
        <img
          src="/recursos/logo_turnos_cuadrantes.png"
          alt="Logo"
          style={{ height: 80, marginRight: 8, cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            textDecoration: "none",
            color: "inherit",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
              color: "inherit",
            },
          }}
          onClick={() => navigate("/")}
        >
          {process.env.REACT_APP_TITULO} | {empresa.nombre}
        </Typography>
        <Tooltip title="Guia de inicio">
          <IconButton
            color="inherit"
            aria-label="Guia de inicio"
            onClick={() => navigate("/guia")}
            sx={{ mr: 1 }}
          >
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Planificador">
          <IconButton
            color="inherit"
            aria-label="Planificador"
            onClick={() => navigate("/Planificador")}
            sx={{ mr: 1 }}
          >
            <CalendarMonth />
          </IconButton>
        </Tooltip>
        <Button
          color="inherit"
          component={Link}
          to="/"
          sx={{
            color: "inherit",
            "&:hover": {
              backgroundColor: "transparent",
              color: "inherit",
            },
          }}
        >
          Dashboard
        </Button>
        <Button color="inherit" onClick={handleMenuClickInformes}>
          {isMobile ? "Inf" : "Informes"}
        </Button>
        <Menu
          anchorEl={anchorElInformes}
          open={openInformes}
          onClose={handleMenuCloseInformes}
        >
          {menuItemsInformes.map(({ label, path }) => (
            <MenuItem key={path} onClick={() => handleNavigate(path)}>
              {label}
            </MenuItem>
          ))}
        </Menu>
        {/* <Button
          color="inherit"
          component={Link}
          to="/Operaciones"
          sx={{
            color: "inherit",
            "&:hover": {
              backgroundColor: "transparent",
              color: "inherit",
            },
          }}
        >
          {isMobile ? "Ops" : "Operaciones"}
        </Button> */}

        {/* <Button
          color="inherit"
          component={Link}
          to="/Informes"
          sx={{
            color: "inherit",
            "&:hover": {
              backgroundColor: "transparent",
              color: "inherit",
            },
          }}
        >
          Informes
        </Button> */}

        <Button color="inherit" onClick={handleMenuClickVisualizacion}>
          {isMobile ? "Lis" : "Listados"}
        </Button>

        <Menu
          anchorEl={anchorElVisualizacion}
          open={openVisualizacion}
          onClose={handleMenuCloseVisualizacion}
        >
          {menuItemsVisualizacion.map(({ label, path }) => (
            <MenuItem key={path} onClick={() => handleNavigate(path)}>
              {label}
            </MenuItem>
          ))}
        </Menu>

        <Button color="inherit" onClick={handleMenuClick}>
          {isMobile ? "Def" : "Definiciones"}
        </Button>

        <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
          {menuItems.map(({ label, path }) => (
            <MenuItem key={path} onClick={() => handleNavigate(path)}>
              {label}
            </MenuItem>
          ))}
        </Menu>

        <Button color="inherit" onClick={onLogout}>
          {isMobile ? <LogoutIcon /> : "Logout"}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default BarraNavegacion;
